import assets from '../../assets/assets';

interface LogoProps {
  size?: string;
  open?: boolean;
}

function WdLogo({ size = '180px', open }: LogoProps) {
  return (
    <>
      {
        open ?
          <img src={assets.poweredBy} style={{ width: size }} />
          :
          <img src={assets.gruppyLogo} style={{ width: size }} />
      }
    </>
  );
}


export default WdLogo;